module.exports = __webpack_public_path__ + "static/img/bgt.9fde60c.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/IntegralProject/images/bgt.png
// module id = e2ye
// module chunks = 5